import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import React from 'react';

export const SelectInput = ({
    label,
    value,
    options,
    onChange,
    disabled = false,
    required = true,
    variant = 'outlined',
    margin = 'none',
}: {
    label: string;
    value: any;
    options: { value: string; label: string, hidden?: boolean }[];
    onChange: (value: any) => void;
    disabled?: boolean;
    required?: boolean;
    variant?: 'outlined' | 'filled' | 'standard';
    margin?:  'normal' | 'dense' | 'none';
}) => {
    return (
        <FormControl fullWidth required={required} margin={margin}>
            <InputLabel style={{paddingLeft: 15, marginTop: -5}}>
                {label}
            </InputLabel>
            <Select
                variant={variant}
                value={value}
                onChange={(event => onChange(event.target.value))}
                label={label}
                disabled={disabled}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.value}
                        value={option.value}
                        style={option.hidden ? { display: 'none' } : {}}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};